import type { RestTimer } from "./types";

export const startRest = (durationSeconds: number, now = Date.now()): RestTimer => ({
  restStartedAt: now,
  restEndAt: now + durationSeconds * 1000,
  durationSeconds,
});

export const remainingRestMs = (timer: RestTimer | undefined, now = Date.now()) =>
  timer ? Math.max(0, timer.pausedRemainingMs ?? timer.restEndAt - now) : 0;

export const formatRestTime = (remainingMs: number) => {
  const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
};

export const adjustRest = (
  timer: RestTimer,
  seconds: number,
  now = Date.now(),
): RestTimer => {
  if (timer.pausedRemainingMs != null) {
    return {
      ...timer,
      pausedRemainingMs: Math.max(0, timer.pausedRemainingMs + seconds * 1000),
    };
  }
  const remaining = remainingRestMs(timer, now);
  return {
    ...timer,
    restEndAt: now + Math.max(0, remaining + seconds * 1000),
  };
};

export const pauseRest = (timer: RestTimer, now = Date.now()): RestTimer => ({
  ...timer,
  pausedRemainingMs: remainingRestMs(timer, now),
});

export const resumeRest = (timer: RestTimer, now = Date.now()): RestTimer => {
  const remaining = timer.pausedRemainingMs ?? 0;
  const base = { ...timer };
  delete base.pausedRemainingMs;
  return { ...base, restEndAt: now + remaining };
};
